import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Subscription = {
    getCustomerAgreement,
    getServices,
    getNotVisibleServices,
    getDealServices,
    processCardPaymentMethod,
    processPaypalPayment,
    getCustomerPlan,
    confirmPaypalPayment,
    cancelSubscription,
    cancelCustomerFeedback,
    getPlanDetails,
    processApplePayment,
    updateCard,
    updatePaymentMethod,
    applyCancelDiscount,
    pauseSubscription,
    reactivateSubscription
}

function getCustomerAgreement(){
    
    const url = 'subscription/get-customer-agreement.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    };
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function updateCard(data){
    
    const url = 'subscription/update-paypal-card.json?store_id=1&lang_code=en';
    data.token= USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function updatePaymentMethod(data){

    const url = 'stripe/update-payment-method.json';
    data.token= USER_TOKEN;
    return axiosReqOther(url, data, 'post').then(res => {
        return res;
    })
    .catch(err => {
    // alert(err.response.data.message)
    return err;
    });
}
function getServices(data){
    console.log(data)
    const url = 'subscription/get-services.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

 function getNotVisibleServices(data){
    console.log(data)
    const url = 'subscription/get-invisible-services.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function getDealServices(data){
    console.log(data)
    const url = 'subscription/get-deal-services.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function processCardPaymentMethod(data){
    
    const url = 'subscription/process-card-payment.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function processPaypalPayment(data){
    
    const url = 'subscription/payment-method.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function getCustomerPlan(data){
    
    const url = 'subscription/get-customer-plan.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function confirmPaypalPayment(data){
    const url = 'subscription/confirm-paypal-payment.json?store_id=1&lang_code=en';
    data.token = USER_TOKEN;
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function cancelSubscription(){
    const url = 'customer/cancel-billing.json?store_id=1&lang_code=en';
    const data = {
        token: USER_TOKEN
    }
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function cancelCustomerFeedback(data){
    const url = 'subscription/send-customer-feedback.json?store_id=1&lang_code=en';
    data.token =  USER_TOKEN;
    
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function getPlanDetails(data){
    const url = 'subscription/get-services-details.json?store_id=1&lang_code=en';
    data.token =  USER_TOKEN;
    
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}
function processApplePayment(data){
    // const url = 'subscription/process-applepay-payment.json?store_id=1&lang_code=en';
    const url = 'stripe/create-subscription.json';
    data.token =  USER_TOKEN;
    
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function applyCancelDiscount(){
    const url = 'subscription/apply-cancel-discount.json?store_id=1&lang_code=en';
    const data = {token:  USER_TOKEN};
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function pauseSubscription(){
    const url = 'subscription/pause-subscription.json?store_id=1&lang_code=en';
    const data = {token:  USER_TOKEN};
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

function reactivateSubscription(){
    const url = 'subscription/un-pause-subscription.json?store_id=1&lang_code=en';
    const data = {token:  USER_TOKEN};
    
    return axiosReqOther(url, data, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
    // alert(err.response.data.message)
    return err; 
    });
}

export default Subscription